

    <div class="header">
        <h2>{{"transcript.deliveryNote"|translate}}</h2>        
        <img alt="Centuri" class="logo"/>
    </div>

    <div class="section">
        <h3>{{transcript.Workflow.Title}} {{transcript.Workflow.UniqueRegistrationNumber}}</h3>
        <h3>{{"transcript.recipients"|translate}}</h3>
        <hr />
        <ol>
            <li ng-repeat="response in transcript.TranscriptResponses">
                {{localize(response.Recipient.Name)}}
            </li>
        </ol>

        <h3>{{"transcript.return"|translate}}</h3>
        <hr />
        {{"transcript.previousIssue"|translate}} {{currentUser.displayName}}

        <h3>{{"transcript.details"|translate}}</h3>
        <hr />                  
        <div c-properties workflow="transcript"></div>

        <h3>{{"transcript.receipt"|translate}}</h3>
        <hr/>
        {{"transcript.sign"|translate}}
        <div>
            <div class="date">{{"transcript.date"|translate}}</div>
            <div class="signature">{{"transcript.signature"|translate}}</div>
        </div>
    </div>
